import React from 'react'
import "./TopReasons.css"
import "./Features.css"

function Features({features}) {
  return (
    <section className='feature-section'>
      <div className='features'>
       <h2 >{features.featureTitle} <span>{features.title_s}</span></h2>
       <p className='features-description'>{features.featureDescription}</p>
       <div className='features-container'>
        {features.featureLists.map((feature,index)=> {
            return <div key={index} className='feature-container'>
                <h2>{feature.title}</h2>
                <p>{feature.description}</p>
            </div>
        })}
       </div>
       </div>
    </section>
  )
}

export default Features